'use client'
import { MessagesKeys, useTranslate } from '@repo/shared/hooks'
import {
  Col,
  Row,
  SegmentedGroup,
  SegmentedGroupItem,
  Typography,
} from '@repo/ui/components'
import { useState } from 'react'
import { timePeriods, timePeriodsMobile } from './dashboard.data'
import { MetricsGrid } from './dashboard.metrics-grid'
import { MyProperties } from './dashboard.my-properties'
import type { TimePeriod } from './dashboard.types'
import { useIsDesktop } from '@repo/ui/hooks'
import { DashboardHistory } from './dashboard.history'
import { DashboardChart } from './dashboard.chat'
import { DashboardReferral } from './dashboard.referral'

export const DashboardContainer = () => {
  const { t } = useTranslate()
  const [selectedPeriod, setSelectedPeriod] = useState<TimePeriod>('1d')

  const isDesktop = useIsDesktop()
  return (
    <Col className='gap-3xl w-full mb-8xl md:mb-0'>
      <Row className='gap-md items-center justify-between md:justify-start p-md md:p-0'>
        <Typography
          variant='h3'
          size='2xl'
          weight='bold'
          color='text-neutral-main'
        >
          {t('dashboardAgent_overall_performance')}
        </Typography>
        <SegmentedGroup
          value={selectedPeriod}
          onValueChange={(value) => setSelectedPeriod(value as TimePeriod)}
          size='sm'
          color='neutral'
        >
          {(isDesktop ? timePeriods : timePeriodsMobile).map((period) => (
            <SegmentedGroupItem key={period.key} value={period.key}>
              {t(period.label as MessagesKeys)}
            </SegmentedGroupItem>
          ))}
        </SegmentedGroup>
      </Row>
      <MetricsGrid timePeriod={selectedPeriod} />
      <DashboardReferral />
      <DashboardChart timePeriod={selectedPeriod} />
      <MyProperties />
      <DashboardHistory />
    </Col>
  )
}
